import styled from 'styled-components';

const FormItem = styled.div`
  :not(:first-child) {
    margin: 20px 0 0 0;
  }
`;

export default FormItem;
